// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".war-room-sprite { display:block; width:100%; height:100%; pointer-events:none; overflow:hidden; }\n", "",{"version":3,"sources":["webpack://./src/features/ProvinceWar/ProvinceWarArt.css"],"names":[],"mappings":"AAAA,mBAAmB,aAAa,EAAE,UAAU,EAAE,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE","sourcesContent":[".war-room-sprite { display:block; width:100%; height:100%; pointer-events:none; overflow:hidden; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
